(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaInstructionDialogController', RcopiaInstructionDialogController);

    RcopiaInstructionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RcopiaInstruction', 'RcopiaDose'];

    function RcopiaInstructionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RcopiaInstruction, RcopiaDose) {
        var vm = this;

        vm.rcopiaInstruction = entity;
        vm.clear = clear;
        vm.save = save;
        vm.rcopiadoses = RcopiaDose.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaInstruction.id !== null) {
                RcopiaInstruction.update(vm.rcopiaInstruction, onSaveSuccess, onSaveError);
            } else {
                RcopiaInstruction.save(vm.rcopiaInstruction, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:rcopiaInstructionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
